// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"5c8098c8","266":"638b3a3f"}[chunkId] + ".chunk.js";
};